import { Controller } from "@hotwired/stimulus"

// Confirm-uncheck controller: when a checkbox is unchecked, show a
// `window.confirm()` dialog. If the user cancels, the checkbox is reverted
// to its previously-checked state.
// Usage:
//   = f.check_box :is_email_confirmation_required, {
//       class: "custom-checkbox",
//       data: {
//         controller: "confirm-uncheck",
//         confirm_uncheck_message_value: "Disabling this will let users sign up without verifying their email. Continue?",
//         action: "change->confirm-uncheck#prompt",
//       },
//     }, true, false
//
// Only triggers when the checkbox is being unchecked; checking is always
// allowed through without a prompt.
export default class extends Controller {
  static values = {
    message: { type: String, default: "Are you sure?" },
  }

  prompt(event) {
    const checkbox = event.target
    if (checkbox.checked) return
    if (!window.confirm(this.messageValue)) {
      checkbox.checked = true
    }
  }
}
